import Vue from 'vue'
import VueComponent from './LeftNav.vue'

let selector = "#vue-component-left-nav",
    element = document.querySelector(selector)

if (element) {
  new Vue({
    render: h => h(VueComponent),
  }).$mount(selector)
} else {
  console.log('No Left Nav Element Found')
}
